class CartDrawer extends HTMLElement {

  constructor() {
    super();

    /* =========================================================
       ESCAPE KEY
    ========================================================= */

    this.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') {
        this.close();
      }
    });

    /* =========================================================
       OVERLAY
    ========================================================= */

    const overlay = this.querySelector('#CartDrawer-Overlay');

    if (overlay) {
      overlay.addEventListener(
        'click',
        this.close.bind(this)
      );
    }

    /* =========================================================
       HEADER CART ICON
    ========================================================= */

    this.setHeaderCartIconAccessibility();
  }


  /* =========================================================
     HEADER CART ICON ACCESSIBILITY
  ========================================================= */

  setHeaderCartIconAccessibility() {

    const cartLink =
      document.querySelector('#cart-icon-bubble');

    if (!cartLink) return;

    cartLink.setAttribute(
      'role',
      'button'
    );

    cartLink.setAttribute(
      'aria-haspopup',
      'dialog'
    );

    cartLink.addEventListener('click', (event) => {

      event.preventDefault();

      this.open(cartLink);

    });

    cartLink.addEventListener('keydown', (event) => {

      if (
        event.code.toUpperCase() === 'SPACE' ||
        event.code.toUpperCase() === 'ENTER'
      ) {

        event.preventDefault();

        this.open(cartLink);

      }

    });
  }


  /* =========================================================
     OPEN CART DRAWER
  ========================================================= */

  open(triggeredBy) {

    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }

    /* =======================================================
       CART DRAWER NOTE / DETAILS
    ======================================================= */

    const cartDrawerNote =
      this.querySelector(
        '[id^="Details-"] summary'
      );

    if (
      cartDrawerNote &&
      !cartDrawerNote.hasAttribute('role')
    ) {

      this.setSummaryAccessibility(
        cartDrawerNote
      );

    }


    /* =======================================================
       ANIMATION
    ======================================================= */

    setTimeout(() => {

      this.classList.add(
        'animate',
        'active'
      );

    }, 10);


    /* =======================================================
       FOCUS TRAP
    ======================================================= */

    this.addEventListener(
      'transitionend',
      () => {

        const containerToTrapFocusOn =
          this.classList.contains('is-empty')
            ? this.querySelector(
                '.drawer__inner-empty'
              )
            : document.getElementById(
                'CartDrawer'
              );

        const focusElement =
          this.querySelector(
            '.drawer__inner'
          ) ||
          this.querySelector(
            '.drawer__close'
          );

        if (
          typeof trapFocus === 'function' &&
          containerToTrapFocusOn
        ) {

          trapFocus(
            containerToTrapFocusOn,
            focusElement
          );

        }

      },
      {
        once: true
      }
    );


    /* =======================================================
       PREVENT BODY SCROLL
    ======================================================= */

    document.body.classList.add(
      'overflow-hidden'
    );
  }


  /* =========================================================
     CLOSE CART DRAWER
  ========================================================= */

  close() {

    this.classList.remove(
      'active'
    );

    if (
      typeof removeTrapFocus === 'function'
    ) {

      removeTrapFocus(
        this.activeElement
      );

    }

    document.body.classList.remove(
      'overflow-hidden'
    );
  }


  /* =========================================================
     SUMMARY ACCESSIBILITY
  ========================================================= */

  setSummaryAccessibility(cartDrawerNote) {

    cartDrawerNote.setAttribute(
      'role',
      'button'
    );

    cartDrawerNote.setAttribute(
      'aria-expanded',
      'false'
    );


    if (
      cartDrawerNote.nextElementSibling &&
      cartDrawerNote.nextElementSibling.getAttribute('id')
    ) {

      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      );

    }


    cartDrawerNote.addEventListener(
      'click',
      (event) => {

        const details =
          event.currentTarget.closest(
            'details'
          );

        if (!details) return;

        event.currentTarget.setAttribute(
          'aria-expanded',
          !details.hasAttribute('open')
        );

      }
    );


    if (
      cartDrawerNote.parentElement &&
      typeof onKeyUpEscape === 'function'
    ) {

      cartDrawerNote.parentElement.addEventListener(
        'keyup',
        onKeyUpEscape
      );

    }
  }


  /* =========================================================
     RENDER CART CONTENTS
  ========================================================= */

  renderContents(parsedState) {

    console.log(
      'CartDrawer renderContents:',
      parsedState
    );


    if (
      !parsedState ||
      !parsedState.sections
    ) {

      console.error(
        'Cart sections are missing:',
        parsedState
      );

      return;
    }


    /* =======================================================
       UPDATE CART DRAWER + CART ICON
    ======================================================= */

    this.getSectionsToRender().forEach(
      (section) => {

        const html =
          parsedState.sections[
            section.id
          ];


        if (!html) {

          console.warn(
            'Missing cart section:',
            section.id
          );

          return;
        }


        const sectionElement =
          section.selector
            ? document.querySelector(
                section.selector
              )
            : document.getElementById(
                section.id
              );


        if (!sectionElement) {

          console.warn(
            'Cart section element not found:',
            section.id,
            section.selector
          );

          return;
        }


        /* =================================================
           GET UPDATED SECTION
        ================================================= */

        const parsedHTML =
          new DOMParser()
            .parseFromString(
              html,
              'text/html'
            );


        let newElement = null;


        if (section.selector) {

          newElement =
            parsedHTML.querySelector(
              section.selector
            );

        } else {

          newElement =
            parsedHTML.getElementById(
              section.id
            );

        }


        if (!newElement) {

          console.warn(
            'Updated section element not found:',
            section.id
          );

          return;
        }


        /* =================================================
           REPLACE CONTENT
        ================================================= */

        sectionElement.innerHTML =
          newElement.innerHTML;

      }
    );


    /* =======================================================
       RE-BIND OVERLAY AFTER HTML UPDATE
    ======================================================= */

    const overlay =
      this.querySelector(
        '#CartDrawer-Overlay'
      );


    if (overlay) {

      overlay.addEventListener(
        'click',
        this.close.bind(this)
      );

    }


    /* =======================================================
       OPEN UPDATED DRAWER
    ======================================================= */

    setTimeout(() => {

      this.open();

    }, 50);

  }


  /* =========================================================
     SECTIONS TO RENDER
  ========================================================= */

  getSectionsToRender() {

    return [

      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },

      {
        id: 'cart-icon-bubble'
      }

    ];

  }


  /* =========================================================
     GET SECTION INNER HTML
  ========================================================= */

  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {

    const parsedHTML =
      new DOMParser()
        .parseFromString(
          html,
          'text/html'
        );


    const element =
      parsedHTML.querySelector(
        selector
      );


    if (!element) {
      return '';
    }


    return element.innerHTML;

  }


  /* =========================================================
     GET SECTION DOM
  ========================================================= */

  getSectionDOM(
    html,
    selector = '.shopify-section'
  ) {

    return new DOMParser()
      .parseFromString(
        html,
        'text/html'
      )
      .querySelector(
        selector
      );

  }


  /* =========================================================
     ACTIVE ELEMENT
  ========================================================= */

  setActiveElement(element) {

    this.activeElement =
      element;

  }

}


/* ============================================================
   DEFINE CART DRAWER
============================================================ */

if (
  !customElements.get(
    'cart-drawer'
  )
) {

  customElements.define(
    'cart-drawer',
    CartDrawer
  );

}


/* ============================================================
   CART DRAWER ITEMS
============================================================ */

class CartDrawerItems extends HTMLElement {


  constructor() {

    super();


    /* ========================================================
       CLICK EVENTS
    ======================================================== */

    this.addEventListener(
      'click',
      this.handleClick.bind(this)
    );


    /* ========================================================
       CHANGE EVENTS
    ======================================================== */

    this.addEventListener(
      'change',
      this.handleChange.bind(this)
    );

  }


  /* ==========================================================
     HANDLE CLICK
  ========================================================== */

  handleClick(event) {

    /* ========================================================
       REMOVE PRODUCT
    ======================================================== */

    const removeButton =
      event.target.closest(
        'cart-remove-button'
      );


    if (removeButton) {

      event.preventDefault();

      this.removeItem(
        removeButton
      );

      return;

    }


    /* ========================================================
       REMOVE BUTTON WITH CLASS
    ======================================================== */

    const removeLink =
      event.target.closest(
        '.cart-remove-button a, [data-cart-remove]'
      );


    if (removeLink) {

      event.preventDefault();

      this.removeItem(
        removeLink
      );

    }

  }


  /* ==========================================================
     HANDLE QUANTITY CHANGE
  ========================================================== */

  handleChange(event) {

    const input =
      event.target.closest(
        'input[name="updates[]"], .quantity__input'
      );


    if (!input) return;


    const line =
      this.getLineNumber(input);


    if (!line) return;


    let quantity =
      parseInt(
        input.value,
        10
      );


    if (
      !Number.isFinite(quantity) ||
      quantity < 0
    ) {

      quantity = 1;

    }


    this.updateCartItem(
      line,
      quantity
    );

  }


  /* ==========================================================
     GET LINE NUMBER
  ========================================================== */

  getLineNumber(element) {

    if (!element) {
      return null;
    }


    /* ========================================================
       DATA INDEX
    ======================================================== */

    const dataIndex =
      element.getAttribute(
        'data-index'
      );


    if (dataIndex) {

      return parseInt(
        dataIndex,
        10
      );

    }


    /* ========================================================
       NAME ATTRIBUTE
    ======================================================== */

    const name =
      element.getAttribute(
        'name'
      );


    if (
      name === 'updates[]'
    ) {

      const inputs =
        Array.from(
          this.querySelectorAll(
            'input[name="updates[]"]'
          )
        );


      const index =
        inputs.indexOf(
          element
        );


      if (index !== -1) {

        return index + 1;

      }

    }


    /* ========================================================
       PARENT DATA INDEX
    ======================================================== */

    const parent =
      element.closest(
        '[data-index]'
      );


    if (parent) {

      return parseInt(
        parent.getAttribute(
          'data-index'
        ),
        10
      );

    }


    return null;

  }


  /* ==========================================================
     REMOVE ITEM
  ========================================================== */

  removeItem(element) {

    let line =
      this.getLineNumber(
        element
      );


    /* ========================================================
       TRY DATA-INDEX FROM PARENT
    ======================================================== */

    if (!line) {

      const parent =
        element.closest(
          '[data-index]'
        );


      if (parent) {

        line =
          parseInt(
            parent.getAttribute(
              'data-index'
            ),
            10
          );

      }

    }


    /* ========================================================
       TRY HREF
    ======================================================== */

    if (!line) {

      const link =
        element.tagName === 'A'
          ? element
          : element.querySelector(
              'a'
            );


      if (link) {

        const href =
          link.getAttribute(
            'href'
          );


        if (href) {

          try {

            const url =
              new URL(
                href,
                window.location.origin
              );


            const lineParam =
              url.searchParams.get(
                'line'
              );


            if (lineParam) {

              line =
                parseInt(
                  lineParam,
                  10
                );

            }

          } catch (error) {

            console.warn(
              'Could not read remove URL:',
              error
            );

          }

        }

      }

    }


    if (!line) {

      console.error(
        'Cart line number could not be found.'
      );

      return;

    }


    console.log(
      'Removing cart line:',
      line
    );


    this.updateCartItem(
      line,
      0
    );

  }


  /* ==========================================================
     UPDATE CART ITEM
  ========================================================== */

  async updateCartItem(
    line,
    quantity
  ) {

    const cartDrawer =
      this.closest(
        'cart-drawer'
      ) ||
      document.querySelector(
        'cart-drawer'
      );


    if (!cartDrawer) {

      console.error(
        'Cart drawer not found.'
      );

      return;

    }


    /* ========================================================
       LOADING STATE
    ======================================================== */

    this.classList.add(
      'loading'
    );


    cartDrawer.classList.add(
      'loading'
    );


    try {

      /* ======================================================
         SHOPIFY CART CHANGE API
      ====================================================== */

      const formData =
        new FormData();

      formData.append(
        'line',
        line
      );

      formData.append(
        'quantity',
        quantity
      );


      /* ======================================================
         REQUEST UPDATED SECTIONS
      ====================================================== */

      formData.append(
        'sections',
        'cart-drawer,cart-icon-bubble'
      );

      formData.append(
        'sections_url',
        window.location.pathname
      );


      /* ======================================================
         SEND REQUEST
      ====================================================== */

      const response =
        await fetch(
          `${window.Shopify.routes.root}cart/change.js`,
          {
            method: 'POST',

            headers: {
              'Accept':
                'application/json'
            },

            body: formData
          }
        );


      if (!response.ok) {

        throw new Error(
          'Cart update failed.'
        );

      }


      /* ======================================================
         GET UPDATED CART
      ====================================================== */

      const parsedState =
        await response.json();


      console.log(
        'Updated cart:',
        parsedState
      );


      /* ======================================================
         RENDER UPDATED DRAWER
      ====================================================== */

      cartDrawer.renderContents(
        parsedState
      );


    } catch (error) {

      console.error(
        'Cart update error:',
        error
      );

      alert(
        'Unable to update cart. Please try again.'
      );


    } finally {

      this.classList.remove(
        'loading'
      );

      cartDrawer.classList.remove(
        'loading'
      );

    }

  }


  /* ==========================================================
     SECTIONS TO RENDER
  ========================================================== */

  getSectionsToRender() {

    return [

      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '#CartDrawer'
      },

      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '#cart-icon-bubble'
      }

    ];

  }

}


/* ============================================================
   DEFINE CART DRAWER ITEMS
============================================================ */

if (
  !customElements.get(
    'cart-drawer-items'
  )
) {

  customElements.define(
    'cart-drawer-items',
    CartDrawerItems
  );

}